export const buildQueryStringList = (name, arr) => {
    if (!arr) return "";
    return arr.length > 0 ? `&${name}=${arr.join(`&${name}=`)}` : "";
};
